import { useAuth, useTheme } from "hooks"

export function useHasBikeFleet() {
	const { entity } = useAuth()
	const {
		currentTheme: { id_api },
	} = useTheme()

	const operator =
		entity?.data_operators?.[0] && entity.data_operators.find((i) => i.operator === id_api)
		
	if (
		operator &&
		operator?.entity_data.account_id &&
		operator.entity_data.hasOwnProperty("is_fleet") &&
		operator.entity_data.is_fleet === true
	) return true

	return false
}
